import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoContainer } from "./components/logo-container/logo-container";
import styles from "./shared-ui-header-v2.module.css";
import { UserProfile } from "./components/user-profile/user-profile";
import { DesktopNav } from "./components/desktop-nav/desktop-nav";
import { MobileNav } from "./components/mobile-nav/mobile-nav";
import { SharedUiHeaderV2Provider } from "./context/context-shared-ui-header-v2";
import { useCallback, useEffect, useState } from "react";
import { useFocusNavigation } from "./hooks/use-focus-navigation";
export var SharedUiHeaderV2 = function(param) {
    var handleTrackEvent = param.handleTrackEvent, stageName = param.stageName, isLoggedIn = param.isLoggedIn, accessToken = param.accessToken, firstName = param.firstName, favourites = param.favourites, children = param.children, refreshActiveOrder = param.refreshActiveOrder, activeOrder = param.activeOrder, checkoutModal = param.checkoutModal, setIsCheckoutModalVisible = param.setIsCheckoutModalVisible, isCheckoutModalVisible = param.isCheckoutModalVisible, shouldShowBasketIcon = param.shouldShowBasketIcon, _isGapMenuItemShown = param.isGapMenuItemShown, isGapMenuItemShown = _isGapMenuItemShown === void 0 ? false : _isGapMenuItemShown, _isUpdatedCinchCareCopy = param.isUpdatedCinchCareCopy, isUpdatedCinchCareCopy = _isUpdatedCinchCareCopy === void 0 ? false : _isUpdatedCinchCareCopy;
    var ref = useState(null), activeMenu = ref[0], setActiveMenu = ref[1];
    var ref1 = useState(false), isMobile = ref1[0], setIsMobile = ref1[1];
    useEffect(function() {
        if ("object" !== "undefined" && window.innerWidth < 768) {
            setIsMobile(true);
        }
    }, []);
    var handleItemSelection = useCallback(function(menuName) {
        if (menuName === activeMenu) {
            setActiveMenu(null);
        } else {
            setActiveMenu(menuName);
        }
    }, [
        activeMenu
    ]);
    var sharedHeaderV2Ref = useFocusNavigation("#main-header", activeMenu);
    return /*#__PURE__*/ _jsx(SharedUiHeaderV2Provider, {
        stageName: stageName,
        isLoggedIn: isLoggedIn,
        accessToken: accessToken,
        firstName: firstName,
        handleTrackEvent: handleTrackEvent,
        favourites: favourites,
        refreshActiveOrder: refreshActiveOrder,
        activeOrder: activeOrder,
        setIsCheckoutModalVisible: setIsCheckoutModalVisible,
        isCheckoutModalVisible: isCheckoutModalVisible,
        isGapMenuItemShown: isGapMenuItemShown,
        isUpdatedCinchCareCopy: isUpdatedCinchCareCopy,
        children: /*#__PURE__*/ _jsxs("header", {
            ref: sharedHeaderV2Ref,
            id: "main-header",
            className: styles.sharedUiHeaderContainer,
            children: [
                /*#__PURE__*/ _jsx("a", {
                    className: styles.sharedUiSkipLink,
                    href: "#main-content",
                    children: "skip to main content"
                }),
                /*#__PURE__*/ _jsx("a", {
                    className: styles.sharedUiSkipLink,
                    href: "#main-footer",
                    children: "skip to footer"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.sharedUiHeaderInnerWrapper,
                    children: /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "Main navigation",
                        className: styles.sharedUiHeaderNav,
                        children: /*#__PURE__*/ _jsxs("ul", {
                            className: styles.sharedUiHeaderTopLevel,
                            children: [
                                /*#__PURE__*/ _jsx(LogoContainer, {}),
                                /*#__PURE__*/ _jsx(DesktopNav, {
                                    isMobile: isMobile,
                                    activeMenu: activeMenu,
                                    handleItemSelection: handleItemSelection,
                                    children: /*#__PURE__*/ _jsx(UserProfile, {
                                        checkoutModal: checkoutModal,
                                        shouldShowBasketIcon: shouldShowBasketIcon ? shouldShowBasketIcon : false
                                    })
                                }),
                                /*#__PURE__*/ _jsx(MobileNav, {
                                    isMobile: isMobile,
                                    checkoutModal: checkoutModal,
                                    activeMenu: activeMenu,
                                    handleItemSelection: handleItemSelection,
                                    shouldShowBasketIcon: shouldShowBasketIcon ? shouldShowBasketIcon : false
                                })
                            ]
                        })
                    })
                }),
                children
            ]
        })
    });
};
